import { NOTES_SERVICE } from "@/services/notes.service.js";

const state = {postNoteOutput: false, getNotesOutput: {}, getNoteByIdOutput: {}, deleteNoteByIdOutput: false, getNoteByCoachingSessionidOutput: {}};

const actions = {
    //Service to create notes
    postNote({ dispatch, commit }, input) {
        dispatch('alert/clear', null, { root: true });
        commit('postNoteRequest');

        NOTES_SERVICE.postNote(input)
            .then(
                output => {
                    commit('postNoteSuccess', output);
                },
                error => {
                    commit('postNoteFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },

    //Service to get paginated notes
    getNotes({ dispatch, commit }, queryParams) {
        dispatch('alert/clear', null, { root: true });
        commit('getNotesRequest');

        NOTES_SERVICE.getNotes(queryParams)
            .then(
                output => {
                    commit('getNotesSuccess', output);
                },
                error => {
                    commit('getNotesFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },

    //Service to get note details
    getNoteById({ dispatch, commit }, queryParams) {
        dispatch('alert/clear', null, { root: true });
        commit('getNoteByIdRequest');

        NOTES_SERVICE.getNoteById(queryParams)
            .then(
                output => {
                    commit('getNoteByIdSuccess', output);
                },
                error => {
                    commit('getNoteByIdFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },

    //Service to delete notes
    deleteNoteById({ dispatch, commit }, queryParams) {
        dispatch('alert/clear', null, { root: true });
        commit('deleteNoteByIdRequest');

        NOTES_SERVICE.deleteNoteById(queryParams)
            .then(
                output => {
                    commit('deleteNoteByIdSuccess', output);
                },
                error => {
                    commit('deleteNoteByIdFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },

    //Service to get notes details by coaching session Id
    getNoteByCoachingSessionid({ dispatch, commit }, queryParams) {
        dispatch('alert/clear', null, { root: true });
        commit('getNoteByCoachingSessionidRequest');

        NOTES_SERVICE.getNoteByCoachingSessionid(queryParams)
            .then(
                output => {
                    commit('getNoteByCoachingSessionidSuccess', output);
                },
                error => {
                    commit('getNoteByCoachingSessionidFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },
};

const mutations = {
    //postNote
    postNoteRequest(state) {
        state.postNoteOutput = null;
    },
    postNoteSuccess(state, output) {
        state.postNoteOutput = true;
    },
    postNoteFailure(state) {
        state.postNoteOutput = false;
    },

    //getNotes
    getNotesRequest(state) {
    },
    getNotesSuccess(state, output) {
        state.getNotesOutput = output;
    },
    getNotesFailure(state) {
        state.getNotesOutput = false;
    },

    //getNoteById
    getNoteByIdRequest(state) {
    },
    getNoteByIdSuccess(state, output) {
        state.getNoteByIdOutput = output;
    },
    getNoteByIdFailure(state) {
        state.getNoteByIdOutput = false;
    },

    //deleteNoteById
    deleteNoteByIdRequest(state) {
        state.deleteNoteByIdOutput = null;
    },
    deleteNoteByIdSuccess(state, output) {
        state.deleteNoteByIdOutput = true;
    },
    deleteNoteByIdFailure(state) {
        state.deleteNoteByIdOutput = false;
    },

    //getNoteByCoachingSessionid
    getNoteByCoachingSessionidRequest(state) {
    },
    getNoteByCoachingSessionidSuccess(state, output) {
        state.getNoteByCoachingSessionidOutput = output;
    },
    getNoteByCoachingSessionidFailure(state) {
        state.getNoteByCoachingSessionidOutput = false;
    },
};

export const notes = {
    namespaced: true,
    state,
    actions,
    mutations
};